<template>
  <div>
    <v-stepper-step :complete="currentStep > isStep" :editable="currentStep > isStep" :step="isStep">Update Tariff</v-stepper-step>
    <v-stepper-content :step="isStep">
      <v-row>
        <v-col>
          <v-row>
            <v-col cols="6">
              <v-select hide-details dense outlined label="Select Tariff" :items="getTariffsByService" @change="selectedTariff(true)" v-model="tariffID"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select hide-details dense outlined label="Select Contract Length" :items="clength_list" @change="selectedLength(true)" v-model="cLength" :disabled="clength_disabled" :loading="clength_loading"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select hide-details dense outlined :label="`${(promos_list.length===0)?'No Promos Available':'Select Promo'}`" :items="promos_list" @change="selectedPromo" v-model="promo" :disabled="promos_disabled||promos_list.length===0" :loading="promos_loading" no-data-text="No Promos Available"></v-select>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-btn color="primary" small @click="nextStep();" :disabled="continueDisabled">Continue</v-btn>
        </v-col>
      </v-row>
    </v-stepper-content>
  </div>
</template>

<script>
  import { mapState,mapActions } from "vuex";
  import TariffJS from './../../../mixins/ChangeTariffTariffs.js';

  export default {
    data() {
      return {
        tariffID: '',
        cLength: '',
        promo: '',
        tariffs: {},
        tariffs_list: [],
        clength_list: [],
        promos_list: [],
        promos_loading: false,
        promos_disabled: true,
        clength_loading: false,
        clength_disabled: true,
      }
    },

    mixins: [TariffJS],

    computed: {
      ...mapState("products", ["productAllTariffs","productAllPromos","selectedTariffPromos"]),

      continueDisabled(){
        let fd = this.formData;
        if(fd.tariff.id===''){ return true; }
        if(fd.cLength===''){ return true; }
        return false;
      },

      getTariffsByService() {
        if(!["PRE_LIVE","CHANGE_PRODUCT"].includes(this.formData.changeReason)) {
          return this.tariffs_list.filter(tariff=>tariff.service===this.siteInitial.tariff.service);
        }
        return this.tariffs_list;
      }
    },

    watch: {
      currentStep: {
        immediate: true,
        handler(newVal) {
          if(newVal === 2) {
            if(this.formData.changeReason !== "RENEWAL") {
              this.promo = this.siteInitial.promo.id;
            } else {
              this.promo = null;
            }
            this.selectedPromo();
          }
        }
      }
    },

    props: ['currentStep','isStep','formData','siteInitial'],

    async mounted () {
      await this.sortTariffs();
      await this.setupSelects();
      
      this.formData.tariff = this.siteInitial.tariff;
      this.formData.cLength = this.siteInitial.cLength;
      this.formData.promo = this.siteInitial.promo;

      this.formData.iniTariff = this.formData.tariff;
      this.formData.iniCLength = this.formData.cLength;
      this.formData.iniPromo = this.formData.promo;
    },

    methods: {
      ...mapActions("products", ["getPromosForTariff"]),
      
      async setupSelects(){
        this.tariffID = this.siteInitial.tariff.id;
        this.cLength = this.siteInitial.cLength;

        await this.selectedTariff(false);
        await this.selectedLength(false);
      },

      nextStep() {
        this.$emit('continue');
      },
    },
  }
</script>

<style lang="scss" scoped>
  .v-application--is-ltr .theme--light.v-stepper--vertical {
    .v-stepper__step {
      padding: 15px;
      margin: 10px;
    }
  }
  .v-stepper__wrapper { padding: 2px !important; }
</style>
